import { render } from "./ToggleButton.vue?vue&type=template&id=3a67764b&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=3a67764b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a67764b"]])

export default __exports__